import type { PrimeVuePTOptions } from 'primevue/config';

export const OverlayPanelDesign: Pick<PrimeVuePTOptions, 'overlaypanel'> = {
    overlaypanel: {
        root: {
            class: [
                'bg-white text-ds-primary-700 border-0 rounded-md shadow-lg',
                'z-40 transform origin-center',
                'absolute mt-3',
                'before:absolute before:w-0 before:-top-3 before:h-0 before:border-transparent before:border-solid before:ml-6 before:border-x-[0.75rem] before:border-b-[0.75rem] before:border-t-0 before:border-b-white dark:before:border-b-ds-primary-900',
                'dark:border dark:border-blue-900/40 dark:bg-ds-primary-900  dark:text-white/80',
            ],
        },
        content: { class: 'p-5 items-center flex' },
        transition: {
            enterFromClass: 'opacity-0 scale-75',
            enterActiveClass: 'transition-transform transition-opacity duration-0 ease-in',
            leaveActiveClass: 'transition-opacity duration-150 ease-linear',
            leaveToClass: 'opacity-0',
        },
    },
};
